const darkTheme = {
    current: "dark",
    images: {
        logoFullHorizontalTransparent: '/logo/logo-full-horizontal-transparent-bright-900px.png',
        logoFullHorizontalTransparentOriginal: '/logo/logo-full-horizontal-transparent-bright-original.png',
        logoFullHorizontalTransparentSvg: '/logo/logo-full-horizontal-transparent-bright.svg',
        logoFullSquareTransparent: '/logo/logo-full-square-transparent-bright-2000px.png',
        logoFullSquareTransparentOriginal: '/logo/logo-full-square-transparent-bright-original.png',
        logoFullSquareTransparentSvg: '/logo/logo-full-square-transparent-bright.svg',
        logoPrimaryHorizontal: '/logo/logo-primary-horizontal-bright-2000px.png',
    },
    colors: {
        text: 'white',
        textAlt: '#000000',

        headerBg: '#212447',
        logoBg: '#212447',

        background: '#212447',
        buttonPrimary: '#68ADB7',
        buttonPrimaryText: '#212447',
        buttonPrimaryTextHover: '#000000',
        menuBg: '#212447',
        menuText: 'white',
        borderContrast: '#F5F9FA',
        landingFormActive: '#68ADB7',

        brandPrimary: '#212447',
        brandSecondary: '#68ADB7',
        primary: '#212447',
        secondary: '#68ADB7',
        primaryHover:'#21D480',
        secondaryHover:'#00C8F5',
        brandTertiary: '#3DD4AD',
        brandTertiaryHover:'#2CC9A2',
        // Add more colors as needed

        brandInfo: '#68ADB7',
        brandSuccess: '#007E33',
        brandWarning: '#FF8800',
        brandError: '#CC0000',

        // Disabled states
        textDisabled: '#888',
        borderDisabled: '#888',

        // Background variants
        backgroundPrimary: '#212447',
        backgroundSecondary: '#212447',
        backgroundAlt: '#1a1d35',
        backgroundTertiary: '#252840',
        tableBackground: '#212447',

        quickActionIcon: '#ffd930',
        // Border colors
        border: '#555',
        borderLight: '#666',
        borderDark: '#333',
        headerBorder: '#68ADB7',

        // Overlay colors
        overlayHover: 'rgba(255, 255, 255, 0.08)',
        overlayDisabled: 'rgba(255, 255, 255, 0.3)',
        overlayTextDisabled: 'rgba(255, 255, 255, 0.5)',

        // Warning variant (for cooldown warnings)
        brandWarningLight: 'rgba(255, 193, 7, 0.9)',
    },
    fonts: {
        primary: 'League Spartan',
    },
    spacing: {
        small: '8px',
        medium: '16px',
        large: '24px',
        // Add more spacing sizes as necessary
    },
    shadows: {
        sidebar: '4px 0 8px rgba(0, 0, 0, 0.15), -4px 0 8px rgba(0, 0, 0, 0.15), 0 4px 8px rgba(0, 0, 0, 0.15)',
        table: '0 8px 24px rgba(0, 0, 0, 0.6)',
        form: '0 4px 12px rgba(0, 0, 0, 0.15)',
    },
    // Text shadow using text color (dark mode: 25% opacity)
    textShadow: '1px 1px 2px rgba(255, 255, 255, 0.25), 1px 0 2px rgba(255, 255, 255, 0.25), 0.5px 0.5px 1.5px rgba(255, 255, 255, 0.25)',
    // Add any other lightTheme properties you need
};

export default darkTheme;
